import {AfterViewChecked, Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {StatService} from './stat.service';
import {UtilsService} from '../../shared/utils/utils.service';
import { TranslateService } from 'ng2-translate';
import {Principal} from '../../shared';
import * as XLSX from 'xlsx';
import { SaisineLineService } from '../saisine';
import { MasterProposalLineService } from '../master-proposal';
import { MasterService } from '../master';
import { UserService } from './../../shared/user/user.service';
import { Observable, Subscription } from 'rxjs';
import {isNullOrUndefined} from 'util';
import {CampaignService} from '../campaign/campaign.service';

export const VIEW_SAISINES_BY_LICENCE = 'view_saisines_by_licence';
export const VIEW_SAISINES_BY_SCHOOL = 'view_saisines_by_school';
export const VIEW_SAISINES_BY_REFUSED_MASTER = 'view_saisines_by_refused_master';
export const VIEW_SAISINES_BY_REGION_AND_ACADEMY = 'view_saisines_by_region_and_academy';
export const VIEW_SAISINES_TOTAL_BY_STATUS  = 'view_saisines_total_by_status';
export const VIEW_RECTORAT_REQUEST_BY_STATUS  = 'view_rectorat_request_by_status';
export const VIEW_STUDENT_PROPOSITION_BY_STATUS  = 'view_student_proposition_by_status';
export const VIEW_SAISINE_RECTORAT  = 'view_saisine_rectorat';
export const VIEW_SAISINE_BY_ACADEMY_AND_STATUS  = 'view_saisine_by_academy_and_status';
export const VIEW_NBSAISINE_BY_LICENCE = 'view_nbsaisine_by_licence';
export const VIEW_REQUEST_BY_SCHOOL_AND_STATUS  = 'view_request_by_school_and_status';
export const VIEW_SYNTHESIS_SAISINES = 'view_synthesis_saisines';
export const VIEW_STUDENT_USERS = 'view_student_users';

@Component({
    selector: 'jhi-stat',
    templateUrl: './stat.component.html'
})
export class StatComponent implements OnInit, AfterViewChecked, OnDestroy {

    viewName: string;
    stats: any[];
    cols: any[];
    multiSortMeta: any[];
    exportFilename: string;
    possibleStatus: any[];
    selectStatus: any[];
    @ViewChild('dtStat') dtStat;
    initialized: boolean;
    tableView = ['', '', '', VIEW_SAISINES_BY_LICENCE, VIEW_SAISINES_BY_SCHOOL, VIEW_SAISINES_BY_REFUSED_MASTER, VIEW_SAISINES_BY_REGION_AND_ACADEMY, VIEW_SAISINES_TOTAL_BY_STATUS, VIEW_STUDENT_PROPOSITION_BY_STATUS, VIEW_SYNTHESIS_SAISINES, ''];
    fileDownload = false;
    viewGraph: Boolean = false;

    private statSubscription: Subscription = new Subscription();

    constructor(
        private statService: StatService,
        public utilsService: UtilsService,
        private translateService: TranslateService,
        private principal: Principal,
        private saisineService: SaisineLineService,
        private masterProposalService: MasterProposalLineService,
        private masterService: MasterService,
        private userService: UserService,
        private campaignService: CampaignService
    ) {}

    ngAfterViewChecked() {
        if ( this.dtStat && !this.initialized ) {
            // wait a tick to avoid one-time devMode
            // unidirectional-data-flow-violation error
            setTimeout(_ => this.defaultFilters());
            this.initialized = true;
        }
    }

    defaultFilters() {
        if (this.initialized) {
            this.dtStat.reset();
            if (this.principal.hasSyncAuthority('ROLE_ACADEMICREGIONRECTOR') && this.viewName === VIEW_SYNTHESIS_SAISINES) {
                this.dtStat.filters['licence_academic_region_label'] = {matchMode: 'contains', value: this.principal.getAcademicRegionLabel()};
            }
            this.dtStat._filter();
        }}

    ngOnInit() {
        this.possibleStatus = this.utilsService.getAllSaisineStatus();
    }

    hasSyncAuthority(role): boolean {
        return this.principal.hasSyncAuthority(role);
    }

    load(viewName) {
        this.viewGraph = false;
        if (this.statSubscription) {
            this.statSubscription.unsubscribe();
        }
        this.statSubscription = this.statService.addStatValues(viewName, this.campaignService.getDisplayedCampaign()).subscribe(stats => {
            this.viewName = viewName;
            this.cols = [];
            this.stats = stats;
            let statKey = Object.keys(stats[0]);
            statKey.forEach(col => {
                let column = { field: col, header: col };
                this.cols.push(column);
            });
            this.exportFilename = this.translateService.instant('stat.exportFilename.' + viewName);
            this.initialized = false;
            this.selectStatus = (this.dtStat && this.dtStat.filters['status']) ? this.dtStat.filters['status'].value : [];
        });
    }

    exportAllTable () {
        this.fileDownload = true;
        let wb: XLSX.WorkBook = XLSX.utils.book_new();
        let campaign = this.campaignService.getDisplayedCampaign();
        Observable.combineLatest(
            this.saisineService.query({'campaign': campaign, 'rows': 2147483647}),
            this.masterProposalService.query({'campaign': campaign, 'rows': 2147483647}),
            this.masterService.query({'campaign': campaign}),
            this.statService.addStatValues(VIEW_SAISINES_BY_LICENCE, campaign),
            this.statService.addStatValues(VIEW_SAISINES_BY_SCHOOL, campaign),
            this.statService.addStatValues(VIEW_SAISINES_BY_REFUSED_MASTER, campaign),
            this.statService.addStatValues(VIEW_SAISINES_BY_REGION_AND_ACADEMY, campaign),
            this.statService.addStatValues(VIEW_SAISINES_TOTAL_BY_STATUS, campaign),
            this.statService.addStatValues(VIEW_STUDENT_PROPOSITION_BY_STATUS, campaign),
            this.statService.addStatValues(VIEW_SYNTHESIS_SAISINES, campaign),
            this.userService.query()
        ).subscribe(([saisines, mastersProposal, masters, stat1, stat2, stat3, stat4, stat5, stat6, stat7, users]) => {
            // Tableau des statistiques
            saisines = saisines.json();
            mastersProposal = mastersProposal.json();
            masters = masters.json();
            users = users.json();
            let tableAllData = [saisines, mastersProposal, masters, stat1, stat2, stat3, stat4, stat5, stat6, stat7, users];
            tableAllData.forEach((tableData, index) => {
                if (tableData.length > 0) {
                    let data = [];
                    let cols = [];
                    let acceptKey = [];
                    let translateName = '';
                    let exportFileName = '';
                    let headerKeys = Object.keys(tableData[0]);
                    switch (tableData) {
                        case stat1:
                        case stat2:
                        case stat3:
                        case stat4:
                        case stat5:
                        case stat6:
                        case stat7:
                            translateName = 'stat.';
                            exportFileName = this.translateService.instant(translateName + 'exportFilename.' + this.tableView[index]);
                            break;
                        case saisines:
                            translateName = 'tmmsaisineApp.saisine.export.';
                            acceptKey = ['reference', 'studentName', 'licenceTitle', 'licenceSchoolLabel', 'firstSubmitDate', 'lastModificationDate', 'status', 'numberStudentProposals', 'numberStudentRefused', 'numberStudentConfirmed', 'licenceAcademyLabel', 'licenceAcademicRegionLabel'];
                            exportFileName =  this.translateService.instant(translateName + 'filename');
                            break;
                        case mastersProposal:
                            acceptKey = ['reference', 'studentName', 'licenceAcademyLabel', 'licenceAcademicRegionLabel', 'masterInm', 'formationLabel', 'masterSchoolName', 'status', 'lastModificationDate', 'academyLabel', 'academicRegionLabel'];
                            translateName = 'tmmsaisineApp.masterProposal.export.';
                            exportFileName = this.translateService.instant(translateName + 'filename');
                            break;
                        case masters:
                            acceptKey = ['masterInm', 'formationLabel', 'masterSchoolName', 'residualVacantPlacesDisplayed', 'attributedPlaces', 'availablePlacesDisplayed', 'residualVacantPlacesLastModificationDate', 'academyLabel', 'academicRegionLabel'];
                            translateName = 'tmmsaisineApp.master.export.';
                            exportFileName = this.translateService.instant(translateName + 'filename');
                            break;
                        case users:
                            acceptKey = ['email', 'profiles', 'info', 'lastModifiedBy', 'lastModifiedDate'];
                            translateName = 'userManagement.';
                            exportFileName = this.translateService.instant(translateName + 'filename');
                            break;
                        default:
                            break;
                    }
                    if (acceptKey.length !== 0) {
                        acceptKey.map(headerKey => {
                            cols.push(headerKey);
                        });
                    } else {
                        headerKeys.map(headerKey => {
                            cols.push(headerKey);
                        });
                    }
                    data.push(cols);

                    tableData.map(rowData => {
                        let line = [];
                        let transco = [];
                        switch (tableData) {
                            case stat1:
                            case stat2:
                            case stat3:
                            case stat4:
                            case stat5:
                            case stat6:
                                data.push(Object.keys(rowData).map(key => rowData[key]));
                                break;
                            case stat7:
                                line = [];
                                transco = this.utilsService.getAllSaisineStatus();
                                headerKeys.forEach(head => {
                                    if (head === 'status') {
                                        transco.forEach(trans => {
                                            if (trans.value === rowData['status']) {
                                                // in_progress du rowdata a changer en 'Brouillon'
                                                rowData['status'] = trans.label;
                                            }
                                        });
                                    }
                                    line.push(rowData['status']);
                                });
                                data.push(Object.keys(rowData).map(key => rowData[key]));
                                break;
                            case saisines:
                                line = [];
                                transco = [
                                    {label: 'Brouillon', value: 0},
                                    {label: 'A vérifier', value: 1},
                                    {label: 'Rejetée', value: 2},
                                    {label: 'Vérifiée', value: 3},
                                    {label: 'Traitée', value: 4},
                                    {label: 'Abandonnée', value: 5},
                                    {label: 'Close', value: 6},
                                    {label: 'Annulée', value: 7}
                                ];
                                acceptKey.map(key => {
                                    if (key === 'status') {
                                        rowData[key] = transco[rowData[key]].label;
                                    }
                                    line.push(rowData[key]);
                                });
                                data.push(line);
                                break;
                            case mastersProposal:
                                line = [];
                                transco = this.utilsService.getAllPropositionStatus();
                                acceptKey.map(key => {
                                    if (key === 'status') {
                                        rowData[key] = transco[rowData[key]].label;
                                    }
                                    line.push(rowData[key]);
                                });
                                data.push(line);
                                break;
                            case masters:
                                line = [];
                                acceptKey.map(key => {
                                    line.push(rowData[key]);
                                });
                                data.push(line);
                                break;
                            case users:
                                line = [];
                                rowData.info = '';
                                if (rowData.academicRegionLabel && rowData.academicRegionLabel.length > 0) {
                                    rowData.info = rowData.academicRegionLabel;
                                }
                                if (rowData.info.length > 0 && rowData.academyLabel && rowData.academyLabel.length > 0) {
                                    rowData.info += ' - ' + rowData.academyLabel;
                                } else if (rowData.academyLabel && rowData.academyLabel.length > 0) {
                                    rowData.info =  rowData.academyLabel;
                                }
                                if (rowData.info.length > 0 && rowData.schoolName && rowData.schoolName.length > 0) {
                                    rowData.info += ' - ' + rowData.schoolName;
                                } else if (rowData.info.length === 0) {
                                    rowData.info = rowData.schoolName;
                                }
                                rowData.profiles = this.utilsService.getAuthoritiesString(rowData.authorities);
                                acceptKey.map(key => {
                                    line.push(rowData[key]);
                                });
                                data.push(line);
                                break;
                            default:
                                break;
                        }
                    });
                    data = this.utilsService.traitementExportDataTable(data);
                    data[0].map((key, indexKey) => {
                        data[0][indexKey] = this.translateService.instant(translateName + key);
                    });

                    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
                    XLSX.utils.book_append_sheet(wb, ws, exportFileName);
                }
            });

            // Creation du fichier
            let today = new Date();
            let dd: any = today.getDate();
            let mm: any = today.getMonth() + 1;
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            let fileName = 'TMM-données-téléservice-' + today.getFullYear() + '-' + mm + '-' + dd + '.xlsx';
            XLSX.writeFile(wb, fileName, {compression: true});
            this.fileDownload = false;
        });
    }

    applyStyleColumn(colHeader): string {
        if (this.viewName === VIEW_SYNTHESIS_SAISINES && !isNullOrUndefined(colHeader)) {
            if (colHeader.indexOf('status') !== -1) {
                return 'columnStatus';
            } else if (colHeader.indexOf('date') !== -1) {
                return 'columnDate';
            } else {
                return 'columnDefault';
            }
        }
    }

    reapplyDefaultTableState(): void {
        this.dtStat.reset();
        this.defaultFilters();
        this.dtStat.multiSortMeta = this.multiSortMeta = [];
    }

    ngOnDestroy() {
        this.statSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/stat/stat.component.ts